import React, { Component } from 'react';
import firebase from "firebase/app";
import 'firebase/firestore';
import "firebase/auth";
import StyleFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import { isNullOrUndefined } from 'util';
import MainLogo from "./icons/LetsGoLogo.png";
import BlueGenericBackground from "./backgrounds/BlueGeneric.jpg";
import GoogleFontLoader from 'react-google-font-loader';
import Img from 'react-image';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SchoolIcon from '@material-ui/icons/School';
import PolicyIcon from '@material-ui/icons/Policy';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HomeIcon from '@material-ui/icons/Home';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import NotificactionsIcon from '@material-ui/icons/Notifications';
import Loader from 'react-loader-spinner';
import * as DbUtils from "../common/DbSvc";
import './UserSession.css';
import UserMeetingsComponent from './sessionPages/UserMeetings';
import MeetingComponent from './sessionPages/userMeeting/Meeting';

class UserSession extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            isUserSignedIn: false,
            showLogin: true,
            userId: '',
            providerId: '',
            meetings: {},
            areMeetingsLoading: false,
            selectedMeetingId: ''
        }

        this.getUiConfig = this.getUiConfig.bind(this);
        this.getAndSetUser = this.getAndSetUser.bind(this);
        this.getMeetings = this.getMeetings.bind(this);
        this.loggedInContent = this.loggedInContent.bind(this);
        this.loggedInView = this.loggedInView.bind(this);
        this.loggedOutView = this.loggedOutView.bind(this);
        this.logout = this.logout.bind(this);
        this.onBackButtonPressed = this.onBackButtonPressed.bind(this);
        this.postSignIn = this.postSignIn.bind(this);
        this.renderGeneralLoggedInView = this.renderGeneralLoggedInView.bind(this);
        this.returnToHomePage = this.returnToHomePage.bind(this);
        this.selectMeeting = this.selectMeeting.bind(this);


        this.userMeetingsListener = null;        
    }

    onBackButtonPressed(){
        this.returnToHomePage();
    }

    returnToHomePage(){
        this.setState({
            selectedMeetingId: ''
        });
    }

    getAndSetUser(){
        if(this.state.isUserSignedIn){
            var uId = this.state.userId;
            DbUtils.readUserFromDb(uId);
        }
    }

    getMeetings(){
        if(this.state.isUserSignedIn && (this.state.selectedMeetingId == '')){
           // this.setState({areMeetingsLoading: true});
            let scope = this;
            let meetings = this.state.meetings;                       
            this.userMeetingsListener = firebase.firestore().collection("Users").doc(this.state.userId).collection("meetings").onSnapshot(
                querySnapshot => {
                    querySnapshot.docChanges().forEach(change => {
                        
                        let meeting = change.doc.data();
                        // console.log(meeting);
                        if (change.type === 'added') {
                            meetings[meeting.id] = meeting;
                        }
                        if (change.type === 'modified') {
                            meetings[meeting.id] = meeting;
                        }
                        if (change.type === 'removed') {
                            delete meetings[meeting.id];
                        }
                        scope.setState({meetings:meetings});
                    });
                }
            )
        }
      }


    loggedInContent(){
        if(this.state.userId!=''){
            return (
                <div className="meeting-list-container">
                    {this.state.meetings?
                    <div>
                        {this.state.areMeetingsLoading?
                                <div style={{margin:'auto',width:'50px'}}>
                                    <Loader 
                                    type="TailSpin"
                                    color="#00BFFF"
                                    height="50"	
                                    width="50"
                                    /> 
                                </div>
                                :
                                <div>
                                    {this.renderGeneralLoggedInView()}
                                </div>
                        }
                    </div>
                        : 
                    null                  
                }
                </div>
            );
        }

        return null;
    }

    loggedInView(){

        return (
            <div>
                <div style={{display: 'block'}}>
                    <header className="toolbar" style={{zIndex:'1'}}>
                        <AppBar position="static">
                            <Toolbar> 
                            {this.state.selectedMeetingId != ''?
                                <IconButton color="inherit" onClick={() => this.onBackButtonPressed()}>
                                    <ArrowBackIcon/>
                                </IconButton> 
                                :
                                null 
                            }   
                            <Typography className="toolbar__logo">
                                FlowPro
                            </Typography>                      
                            <div style={{flexGrow: '1'}}></div>
                            <IconButton color="inherit" onClick={() => {this.returnToHomePage()}}>
                                <HomeIcon/>
                            </IconButton>                    
                            <IconButton color="inherit" onClick={() => {}}>
                                <Badge badgeContent={0} color="secondary">
                                    <NotificactionsIcon />
                                </Badge>                           
                            </IconButton>                        
                            <Typography className="userName">
                                {this.state.userId}
                            </Typography>
                            <Button color="inherit" onClick={() => this.logout()}>Logout</Button>
                            </Toolbar>
                        </AppBar>                   
                    </header>
                </div>
                <div>
                    <div className="logged-in-content">
                        {this.state.selectedMeetingId == '' || !(this.state.selectedMeetingId in this.state.meetings)?
                            this.loggedInContent()
                            :
                            <div>
                                <MeetingComponent
                                    meeting = {this.state.meetings[this.state.selectedMeetingId]} 
                                    userId = {this.state.userId}
                                 />
                            </div>
                            }
                    </div>
                </div>
            </div>
        );
        
    }

    loggedOutView(){
        var mainLogoList = [MainLogo];

        return (
            <div>                
              <main style={{height:'100vh',overflow:'hidden'}}>
              
                    <div style={{height:'100vh',overflow:'auto'}}>
                        <img class="background-image blueImage" src={BlueGenericBackground}></img>
                        <GoogleFontLoader
                          fonts={[
                              {
                              font: 'Roboto',
                              weights: [400, '400i'],
                              },
                              {
                              font: 'Roboto Mono',
                              weights: [400, 700],
                              },
                              {
                                  font: 'Bungee Inline',
                                  weights: [400]
                              },
                              {
                                  font:'Lora',
                                  weights: [400]
                              }
                          ]}
                          subsets={['cyrillic-ext', 'greek']}
                          />                        

                        <div className="landing-view-container">                       
                            <div style={{textAlign:'center'}}>
                                <img src={MainLogo} style={{width:'180px', marginTop:'20px'}}/>
                            </div>
                            <div style={{fontFamily: 'Lora, bold-italic', textAlign:'center', fontSize: '18px', fontWeight:'bold', marginTop:'10px'}}><span>Prepare better for your next meeting</span></div>
                                {this.state.showLogin?
                                <div className="user-session-login-container-v2">                                     
                                    <div className='user-session-shadow-view-v2'>
                                        <div>
                                            <span className="userSessionLoginHeader">Login</span>
                                        </div>                                        
                                        <StyleFirebaseAuth
                                        uiConfig={this.getUiConfig()}
                                        firebaseAuth={firebase.auth()}                            
                                        />
                                    </div>
                                </div> 
                                : 
                                    null 
                                }
                                                                    
                                </div>
                            <div>                                                    
                        </div>
                    </div>
                      
                </main>
            </div>
        );
    }

    getUiConfig(){
        let uiConfig = {
            signInFlow: "popup",
            credentialHelper: 'none',
            signInOptions: [
                {
                    provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                    defaultCountry: 'IN'                
                }            
            ],
            callbacks:{
              signInSuccess: () => false,
              signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                
                //...
              }      
            }
          }

        if(window.innerWidth > 768){
            uiConfig.signInOptions.push(firebase.auth.GoogleAuthProvider.PROVIDER_ID);
            uiConfig.signInOptions.push(firebase.auth.EmailAuthProvider.PROVIDER_ID);
        }
        return uiConfig;
    }

    async logout(){
        await firebase.auth().signOut();
        await localStorage.setItem('isUserSignedIn',false);
        await localStorage.removeItem('userId');
        await localStorage.removeItem('providerId');
        await this.setState({
            isUserSignedIn: false,
            isWallOpened: false,
            isNotificationsOpened: false,
            isGameListOpened: false
        });        
        window.location.href = "/";
    }

    renderGeneralLoggedInView(){

        return (
            <div>
                <UserMeetingsComponent 
                    userId = {this.state.userId}
                    meetings = {this.state.meetings}
                    selectedMeeting = {this.state.selectedMeetingId}
                    selectMeeting = {this.selectMeeting}
                    />

            </div>
        )
    }

    selectMeeting(meeting){   
        if(!isNullOrUndefined(meeting.id)){
            this.setState({
                selectedMeetingId: meeting.id 
            });
        }   
    }

    postSignIn(){
        this.getAndSetUser();
        this.getMeetings();
    }

    componentDidMount(){

        if(this.state.isUserSignedIn){
            this.postSignIn();
        }

            firebase.auth().onAuthStateChanged(user =>{

                var oldState = this.state.isUserSignedIn;
                this.setState({
                    isUserSignedIn: !!user
                });

                var providerId = '';
                var uId = '';
                
                if(!isNullOrUndefined(firebase.auth().currentUser) && 
                !isNullOrUndefined(firebase.auth().currentUser.providerData) &&
                firebase.auth().currentUser.providerData.length>0){
                    providerId = firebase.auth().currentUser.providerData[0].providerId;
                }
                if(providerId=="phone"){
                    uId = firebase.auth().currentUser.phoneNumber;
                }
                else if(providerId=='google.com'){
                    uId = firebase.auth().currentUser.email;
                }
                else if(providerId=='password'){
                    uId = firebase.auth().currentUser.email;
                }

                this.setState({
                    providerId: providerId,
                    userId: uId
                });

            // console.log(firebase.auth().currentUser);

                if(!!user && !isNullOrUndefined(firebase.auth().currentUser) && !oldState){               
                    this.postSignIn();
                }
            });

      }

    componentWillUnmount(){
        if(!isNullOrUndefined(this.userMeetingsListner)){
            this.userMeetingsListener();
        }
    }

    render(){

        return (
            <div>
                {this.state.isUserSignedIn?
                    this.loggedInView()
                        :
                    this.loggedOutView()
                }
            </div>
        )
    }
}
export default UserSession;